module.exports = __webpack_public_path__ + "static/media/landing-main-image.7ef46b89.jpg";